import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { openCitySelect } from '~/src/components/CitySelectContainer/store/actionCreators';
import NoSSR from '~/src/helpers/noSSR';
import { getCurrentCity } from '~/src/store/selectors/city';

import * as ST from './styled';

export const ConfirmCitySelection = () => {
    const dispatch = useDispatch();
    const city = useSelector(getCurrentCity);
    const openCitySelectHandler = () => dispatch(openCitySelect());

    return <NoSSR>
        <ST.CityConfirmationBlock>
            <ST.StyledCitySelection
                city={city}
                onBackClick={openCitySelectHandler}
                data-test='city-selection'
            />
        </ST.CityConfirmationBlock>
    </NoSSR>;
};
